var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('progress-bar',{attrs:{"value":scope.row[_vm.$attrs.prop],"percentage":_vm.percentage(scope.row)}})]}}])},'el-table-column',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }